import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as applicationActions from '../../actions/application';
import ImageBackground from '../common/imageBackground';
import NavigationBar from '../common/navigationBar';
import ImageButtonList from '../common/imageButtonList';
import './styles.css';

class Call extends Component {
  /**************
   * Properties *
   **************/
  state = {
    background: {
      id: 'background',
      src: require('./images/Web_demo_telehealth.jpg'),
    },
    buttonList: {
      width: 0,
      height: 0,
    },
    buttons: [
      {
        id: 'telehealthEnter',
        to: '/main_menu',
        unhighlight: require('../common/images/empty.png'),
        highlight: require('../common/images/empty.png'),
        alt: '',
      },
    ],
  };

  render() {
    return (
      <div>
        <ImageBackground {...this.state.background} className="telehealth" />
        <ImageButtonList
          {...this.state.buttonList}
          imageButtons={this.state.buttons}
        />
        <NavigationBar {...this.state.navigationBar} />
      </div>
    );
  }
}

const ConnectedCall = connect(
  (state) => ({
    context: state.application.currentContext,
    currentPatient: state.application.currentPatient,
  }),
  (dispatch) => ({
    actions: bindActionCreators(
      {
        ...applicationActions,
      },
      dispatch
    ),
  })
)(Call);

export default withRouter(ConnectedCall);
